// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;&#145;Rescue the weak and the poor;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;deliver them from the hand of the wicked.<br> </p> </div></div>";
// Exports
module.exports = code;